import numeral from "numeral";

export const currencyFormatter = (value) => {
  return numeral(value).format("0,0");
};
